<template>
  <div>
    <input
      class="form-control form-control-sm"
      v-model="search"
      placeholder="Buscar..."
    />
    <div class="tag-tab rounded mb-3 px-1 py-3">
      <div
        v-for="item in filteredTags"
        @click="selectTag( item )"
        :class="{
          'd-inline px-2 py-1 m-1 text-white rounded tags': true,
          'bg-dark': !item.selected,
          'bg-akdemica': item.selected
        }"
        :key="item.id"
      >{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data () {
    return {
      items: [],
      selected: [],
      search: ""
    }
  },
  computed: {
    filteredTags: function () {
      return this.items.filter(item => {
        return item.text.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    getTags: function () {
      Axios.get('/tags?nopg')
        .then( res => {
          this.items = res.data.data
        })
    },

    selectTag: function ( item ) {
      this.items.forEach(element => {
        if ( element.id === item.id ) this.$set(element, "selected", !element.selected)
      })
    },
  },
  mounted () {
    this.getTags()
  }
}
</script>
